import { Card, Col, Form, Row, Skeleton, Spin } from 'antd';
import { Formik } from 'formik';
import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { useNavigate, useParams } from 'react-router-dom';
import { useBreadcrumbContext } from '../../../../domain/utility/AppContextProvider/BreadcrumbContextProvider';
import IntlMessages from '../../../../domain/utility/IntlMessages';
import { popupConfirm } from '../../../../shared/components/popup-confirm';
import { BannerStatus, BannerTypes } from '../../../../shared/constants/AppEnums';
import { bannersService } from '../../../../shared/services/banners';
import {
  AvailableBannersDto,
  BannersListDto,
} from '../../../../shared/services/banners/dto/banners-list-dto';
import { CreateOrEditBannerDto } from '../../../../shared/services/banners/dto/create-or-edit-banner-dto';
import CreateOrEditBannerHeader from './create-or-edit-banners-header';
import CreateOrEditBannerInfo from './create-or-edit-banners-info';
import BannerPoductsList from './create-or-edit-banners-info/banner-products';
import { schema } from './schema';
import MainUtils from 'src/shared/utils/main';
import { useLocaleContext } from 'src/domain/utility/AppContextProvider/LocaleContextProvide';
import { getLocaleValue } from 'src/shared/functions/change-locales';
import LanguageCode from 'src/shared/services/types/language-code';

interface ICreateOrEditBannerProps { }

const CreateOrEditBanner = (props: ICreateOrEditBannerProps) => {
  const { setBreadcrumb }: any = useBreadcrumbContext();

  const { messages } = useIntl();

  const navigate = useNavigate();

  const { id } = useParams();

  const [isBannerDetailsLoading, setIsBannerDetailsLoading] = useState(false);

  const [initialValuesForm, setInitialValuesForm] =
    useState<CreateOrEditBannerDto>();

  const [bannerDetails, setBannerDetails] = useState<BannersListDto>();

  const [mainCategories, setMainCategories] = useState<AvailableBannersDto[]>(
    [],
  );

  const [subCategories, setSubCategories] = useState<AvailableBannersDto[]>([]);

  const [positioins, setPositioins] = useState<AvailableBannersDto[]>([]);

  const [bannerTypes, setBannerTypes] = useState<AvailableBannersDto[]>([]);

  const [saveAndContinue, setSaveAndContinue] = useState(false);

  const [bannerTypeSelected, setBannerTypeSelected] = useState('');

  const [refresh, setRefresh] = useState(false);

  const { locale }: any = useLocaleContext();
  useEffect(() => {
    if (id) {
      (async () => {
        try {
          setIsBannerDetailsLoading(true);
          let initializeValue = await bannersService.getBannerById(id);
          setMainCategories(initializeValue?.AvailableMainCategories);
          setSubCategories(initializeValue?.AvailableSubCategories);
          setPositioins(initializeValue?.AvialablePositioins);
          setBannerTypes(initializeValue?.AvailableBannerTypes);
          setInitialValuesForm({
            id: initializeValue?.Id,
            isTimed: initializeValue?.IsTimed,
            showName: initializeValue?.ShowName,
            status: initializeValue?.Status,
            shopId: initializeValue?.ShopId,
            name: initializeValue?.Name,
            startDate: initializeValue?.StartDate,
            endDate: initializeValue?.EndDate,
            type: initializeValue?.TypeValue,
            mainCategoryId: initializeValue?.MainCategoryId,
            position: initializeValue?.Position,
            subCategoryId:
              initializeValue?.TypeValue === BannerTypes.SubCategory &&
                !MainUtils.isEmptyValue(initializeValue?.SubCategoryId)
                ? initializeValue?.SubCategoryId
                : undefined,
            showProducts: initializeValue?.ShowProducts,
            url: !MainUtils.isEmptyValue(initializeValue?.Url)
              ? initializeValue?.Url
              : undefined,
            attachment: initializeValue?.Attachment,
            smallPicture: initializeValue?.SmallPicture,
            locales:
              initializeValue?.Locales?.map((item) => {
                return {
                  id: item.Id,
                  languageId: item.LanguageId,
                  localeKey: item.LocaleKey,
                  localeValue: item.LocaleValue,
                };
              }) ?? [],
          });
          setBannerDetails(initializeValue);
        } catch (error) {
          console.error(error);
        } finally {
          setIsBannerDetailsLoading(false);
        }
      })();
    } else {
      (async () => {
        try {
          setIsBannerDetailsLoading(true);
          let initializeValue = await bannersService.initializeBannerValues();
          setMainCategories(initializeValue?.AvailableMainCategories ?? []);
          setSubCategories(initializeValue?.AvailableSubCategories ?? []);
          setPositioins(initializeValue?.AvialablePositioins ?? []);
          setBannerTypes(initializeValue?.AvailableBannerTypes ?? []);
          setInitialValuesForm({
            name: '',
            startDate: '',
            endDate: '',
            status: BannerStatus.Approved,
            type: initializeValue?.TypeValue,
            mainCategoryId: initializeValue?.MainCategoryId,
            position: initializeValue?.Position,
            subCategoryId:
              initializeValue?.AvailableSubCategories?.length > 0
                ? initializeValue?.AvailableSubCategories[0].Value
                : '',
            showProducts: initializeValue?.ShowProducts,
          });
        } catch (error) {
          console.error(error);
        } finally {
          setIsBannerDetailsLoading(false);
        }
      })();
    }
  }, [id, refresh]);

  useEffect(() => {
    setBreadcrumb([
      {
        text: <IntlMessages id='promotions.sideBarName' />,
        url: '/promotions/banners',
      },
      {
        text: <IntlMessages id='promotions.banners' />,
        url: '/promotions/banners',
      },
      id
        ? {
          text: <IntlMessages id='common.edit' />,
          url: `/promotions/banners/edit-banner/${id}`,
        }
        : {
          text: <IntlMessages id='common.create' />,
          url: '/promotions/banners/create-banner',
        },
    ]);
  }, [id]);

  const handleBannertypeValue = (type: string) => {
    switch (type) {
      case BannerTypes.SubCategory:
        return 1;

      case BannerTypes.Url:
        return 2;

      case BannerTypes.Products:
        return 3;

      default:
        return 0;
    }
  };

  const deleteBanner = () => {
    popupConfirm(async () => {
      try {
        let checkDelete = await bannersService.deleteBanner(
          bannerDetails?.Id ?? '',
        );
        if (!Object.prototype.hasOwnProperty.call(checkDelete, 'error'))
          navigate('/promotions/banners');
      } catch (error) {
        console.error(error);
      }
    }, `${messages['commom.areYouSureYouWantToDelete'].toString()}` + ' ' + [bannerDetails?.Locales?.find((item) => item.LanguageId === locale.code)?.LocaleValue ?? bannerDetails?.Name] + `?`);
  };

  const handleSubmit = async (values: any, setSubmitting: any) => {
    try {
      let checkCreateOrEdit: any;
      if (!bannerDetails)
        checkCreateOrEdit = await bannersService.create({
          ...values,
          name: !MainUtils.isEmptyValue(
            getLocaleValue(values?.locales, LanguageCode.English, 'name'),
          )
            ? getLocaleValue(values?.locales, LanguageCode.English, 'name')
            : getLocaleValue(values?.locales, LanguageCode.Arabic, 'name'),
          type: handleBannertypeValue(values.type),
        });
      else
        checkCreateOrEdit = await bannersService.edit({
          ...values,
          name: !MainUtils.isEmptyValue(
            getLocaleValue(values?.locales, LanguageCode.English, 'name'),
          )
            ? getLocaleValue(values?.locales, LanguageCode.English, 'name')
            : getLocaleValue(values?.locales, LanguageCode.Arabic, 'name'),
          startDate: new Date(values.startDate).toISOString(),
          endDate: new Date(values.endDate).toISOString(),
          type: handleBannertypeValue(values.type),
        });
      if (!Object.prototype.hasOwnProperty.call(checkCreateOrEdit, 'error'))
        if (saveAndContinue) {
          navigate(`/promotions/banners/edit-banner/${checkCreateOrEdit.Id}`, {
            state: {
              name: checkCreateOrEdit.Name,
            },
          });
          setRefresh(!refresh);
        } else {
          navigate('/promotions/banners');
        }
    } catch (error) {
      console.error(error);
    } finally {
      setSubmitting(false);
    }
  };
  return (
    <Card>
      <Row gutter={[0, 48]}>
        <Col span={24}>
          <Formik
            enableReinitialize
            initialValues={initialValuesForm ?? {}}
            validationSchema={schema(messages)}
            onSubmit={(values, { setSubmitting }: any) =>
              handleSubmit(values, setSubmitting)
            }
            validateOnChange={false}
            validateOnBlur={false}>
            {({ handleSubmit, isSubmitting, values }: any) => (
              <Form>
                <Skeleton active loading={isBannerDetailsLoading}>
                  <Row gutter={[0, 48]}>
                    <Col span={24}>
                      <CreateOrEditBannerHeader
                        bannerDetails={bannerDetails}
                        saveAndContinue={saveAndContinue}
                        setSaveAndContinue={setSaveAndContinue}
                        isSubmitting={isSubmitting}
                        handleSubmit={handleSubmit}
                        deleteBanner={deleteBanner}
                      />
                    </Col>

                    <Col span={24}>
                      <CreateOrEditBannerInfo
                        bannerDetails={bannerDetails}
                        mainCategories={mainCategories}
                        subCategories={subCategories}
                        positioins={positioins}
                        setBannerTypeSelected={setBannerTypeSelected}
                        bannerTypes={bannerTypes}
                      />
                    </Col>

                    <Col span={24}>
                      {`${bannerTypeSelected}` === BannerTypes.Products &&
                        bannerDetails && (
                          <Spin spinning={bannerDetails ? false : true}>
                            <Col span={24}>
                              <BannerPoductsList
                                mainCategoryId={values.mainCategoryId}
                                bannerDetails={bannerDetails}
                              />
                            </Col>
                          </Spin>
                        )}
                    </Col>
                  </Row>
                </Skeleton>
              </Form>
            )}
          </Formik>
        </Col>
      </Row>
    </Card>
  );
};

export default CreateOrEditBanner;
